import { hasCorePlatformPlan } from "./consoleHome";

/**
 * Settings sidebar keys visible for the current org + role.
 * VoC admin tools (advisor history, genai queue, engagement, email reports,
 * AI credits, topic library, integrations, MI preview) require a core
 * platform base (VoC / MI / Full). Prospect-only and Survey-only orgs
 * keep account basics + Preferences (+ Plan/Teams when role allows).
 */
export function resolveVisibleSettingsSidebarKeys({
  plan,
  isAdmin = false,
  canManageTeams = false,
  isEnterprisePowerUser = false,
  subscriptionRow = null,
} = {}) {
  const hasCore = hasCorePlatformPlan(subscriptionRow);
  const isPlan68 = plan === 68;
  const keys = ["home", "details", "security"];

  if (isPlan68) {
    keys.push("plan");
    return keys;
  }

  keys.push("preferences");

  if (hasCore) {
    keys.push("integrations");
  }

  if (isAdmin) {
    keys.push("plan");
  }

  if (isAdmin || canManageTeams) {
    keys.push("teams", "users");
  }

  if (isAdmin && hasCore) {
    keys.push(
      "advisor-history",
      "genai-queue",
      "engagement",
      "email-reports",
    );
  }

  if (isEnterprisePowerUser && hasCore) {
    keys.push("market-intelligence-preview");
  }

  if (hasCore) {
    keys.push("ai-credits", "topic-library");
  }

  return keys;
}

export function isSettingsSidebarKeyVisible(key, ctx) {
  if (!key) return true;
  return resolveVisibleSettingsSidebarKeys(ctx).includes(key);
}
